import { sportDontHaveImage } from 'api/mockSportCategory';
import { useAppTranslation } from 'app/hooks';
import baseball_image from 'assets/images/category/baseball.png';
import basketball_image from 'assets/images/category/basketball.png';
import boxing from 'assets/images/category/boxing.png';
import cricket from 'assets/images/category/cricket.png';
import esports from 'assets/images/category/esport.png';
import football_image from 'assets/images/category/football.png';
import golf from 'assets/images/category/golf.png';
import hockey_image from 'assets/images/category/hockey.png';
import mma from 'assets/images/category/mma.png';
import soccer_image from 'assets/images/category/soccer.png';
import tennis from 'assets/images/category/tennis.png';
import { IMG_ALT } from 'consts/app';
import Typo from 'consts/typography';
import { GameResponseModel } from 'models';
import { FaAngleRight } from 'react-icons/fa';
import { formatDateNoSeconds } from 'utils/dateUtils';

interface StreamingGameItemProps {
  category?: string;
  handlGameClick: (game: GameResponseModel) => void;
  game: GameResponseModel;
}

const images = [
  '',
  football_image,
  baseball_image,
  basketball_image,
  hockey_image,
  soccer_image,
  tennis,
  golf,
  mma,
  boxing,
  cricket,
  esports,
];

const getImg = (category: string) => {
  switch (category) {
    case 'American Football':
    case 'Football':
      return images[1];
    case 'Baseball':
      return images[2];
    case 'Basketball':
      return images[3];
    case 'Ice Hockey':
    case 'Hockey':
      return images[4];
    case 'Soccer':
      return images[5];
    case 'MMA':
      return images[8];
    case 'Tennis':
      return images[6];
    case 'Golf':
      return images[7];
    case 'Boxing':
      return images[9];
    case 'cricket':
      return images[10];
    case 'eSports':
      return images[11];
    default:
      return images[0];
  }
};

const StreamingGameItem: React.FC<StreamingGameItemProps> = ({ game, handlGameClick }) => {
  const t = useAppTranslation();

  return (
    <div className="live-game-container">
      <div className="category">
        <div className="img-category ">
          <img src={getImg(game.sport.group)} />
        </div>
        <div className={`category-name ${Typo.p7}`}>
          <p>{game.sport.title}</p>
          <span className={Typo.p7}>{formatDateNoSeconds(game.startDate)}</span>
        </div>
      </div>

      <div className="game-detail">
        <div className="team-detail homeTeam">
          <div className="teamName">{game.homeTeam}</div>
          {!sportDontHaveImage.includes(game.sport.group.toLowerCase()) && (
            <div className="team-image">
              <img
                onError={(e) => {
                  e.currentTarget.src = '/defaultImage.png';
                }}
                src={game.homeTeamLogo}
                alt={IMG_ALT}
                className="h-6"
              />
            </div>
          )}
        </div>
        <div className="vs primary-text-color">vs</div>
        <div className="team-detail awayTeam">
          <div className="teamName">{game.awayTeam}</div>
          {!sportDontHaveImage.includes(game.sport.group.toLowerCase()) && (
            <div className="team-image">
              <img
                onError={(e) => {
                  e.currentTarget.src = '/defaultImage.png';
                }}
                src={game.awayTeamLogo}
                alt={IMG_ALT}
                className="h-6"
              />
            </div>
          )}
        </div>
      </div>
      <div className="category-container">
        <div className={`live ${game.status === 'LIVE' ? '' : 'upcoming'}`}>
          <div className="dot-red "></div>
          <span> {t('live')}</span>
        </div>
        <div className="cursor-pointer go-to-stream-btn" onClick={() => handlGameClick(game)}>
          <FaAngleRight className="w-5 h-5 primary-text-color" />
        </div>
      </div>
      <div className="mobile-info">
        <div className="category">
          <div className="img-category ">
            <img src={getImg(game.sport.group)} />
          </div>
          <div className={`category-name ${Typo.p7}`}>
            <p>{game.sport.title}</p>
            <span className={Typo.p7}>{formatDateNoSeconds(game.startDate)}</span>
          </div>
        </div>
        <div className="category-container">
          <div className={`live ${game.status === 'LIVE' ? '' : 'upcoming'}`}>
            <div className="dot-red "></div>
            <span> {t('live')}</span>
          </div>
          <div className="cursor-pointer go-to-stream-btn" onClick={() => handlGameClick(game)}>
            <FaAngleRight className="w-5 h-5 primary-text-color" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default StreamingGameItem;
